import { Box, Flex } from '@chakra-ui/react';

export default function BrowserNavigationBar(props: { url?: string }) {
	return (
		<Box
			alignItems="center"
			bg="gray.100"
			p="1"
			position="relative"
			overflow="hidden"
			whiteSpace="nowrap"
			textOverflow="ellipsis"
			wordBreak="break-all"
			cursor="pointer"
		>
			<Flex
				background="white"
				borderRadius="lg"
				alignItems="center"
				justifyContent="space-between"
				py="1"
				px="1"
			></Flex>
		</Box>
	);
}
